module.exports = __webpack_public_path__ + "img/Agreement Icon.77090b71.svg";